import { Filter } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import { FILTER_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component, SortOrder } from './types';

export const SortBar: Component = ({
  numberOfFilter,
  numberOfCars,
  isSearchPending,
  sorter,
  onFilterClick,
  onSortChange,
  isTopRounded,
}) => {
  const handleFilterClick = () => {
    onFilterClick?.();
  };

  const handleArrowClick = (value: SortOrder) => () => {
    onSortChange?.({
      value,
      isChecked: sorter !== value,
    });
  };

  return (
    <div className={cx(styles.containerRoot, isTopRounded
      ? styles.topRounded
      : styles.bottomRounded)}>
      <span className={styles.textResult}>
        {(numberOfCars && numberOfCars > 0) ? `${numberOfCars} Cars` : ''}
      </span>
      <div className={styles.containerFields}>
        <div className={styles.containerCarModel}>
          <span className={styles.textCarModel}>Car Model</span>
          <div className={styles.containerArrowButtons}>
            <button
              aria-label="Car Model Ascend"
              className={cx(
                styles.arrowButton,
                sorter === 'name,asc' && styles.isActive,
              )}
              disabled={isSearchPending}
              type="button"
              onClick={handleArrowClick('name,asc')}>
              { sorter === 'name,asc'
                ? null
                : <div className={styles.arrowUp} />}
            </button>
            <button
              aria-label="Car Model Descend"
              className={cx(
                styles.arrowButton,
                sorter === 'name,desc' && styles.isActive,
              )}
              disabled={isSearchPending}
              type="button"
              onClick={handleArrowClick('name,desc')}>
              { sorter === 'name,desc'
                ? null
                : <div className={styles.arrowDown} />}
            </button>
          </div>
        </div>
        <div className={styles.containerPrice}>
          <span className={styles.textPrice}>Price</span>
          <div className={styles.containerArrowButtons}>
            <button
              aria-label="Price Ascend"
              className={cx(
                styles.arrowButton,
                sorter === 'price,asc' && styles.isActive,
              )}
              disabled={isSearchPending}
              type="button"
              onClick={handleArrowClick('price,asc')}>
              { sorter === 'price,asc'
                ? null
                : <div className={styles.arrowUp} /> }
            </button>
            <button
              aria-label="Price Descend"
              className={cx(
                styles.arrowButton,
                sorter === 'price,desc' && styles.isActive,
              )}
              disabled={isSearchPending}
              type="button"
              onClick={handleArrowClick('price,desc')}>
              { sorter === 'price,desc'
                ? null
                : <div className={styles.arrowDown} />}
            </button>
          </div>
        </div>
        <span className={styles.textSpecs}>Specs</span>
      </div>
      <div className={styles.containerButtons}>
        <button
          aria-label="filter"
          className={styles.filterButton}
          type="button"
          onClick={handleFilterClick}>
          <Filter size={FILTER_ICON_SIZE} />
          {numberOfFilter !== 0 && (
            <span className={styles.textNumberOfFilter}>
              {numberOfFilter}
            </span>
          )}
        </button>
      </div>
      <div className={styles.containerUserRatings}>
        <span className={styles.textUserRatings}>User Ratings</span>
        <div className={styles.containerArrowButtons}>
          <button
            aria-label="Ratings Ascend"
            className={cx(
              styles.arrowButton,
              sorter === 'rating,asc' && styles.isActive,
            )}
            disabled={isSearchPending}
            type="button"
            onClick={handleArrowClick('rating,asc')}>
            { sorter === 'rating,asc'
              ? null
              : <div className={styles.arrowUp} /> }
          </button>
          <button
            aria-label="Ratings Descend"
            className={cx(
              styles.arrowButton,
              sorter === 'rating,desc' && styles.isActive,
            )}
            disabled={isSearchPending}
            type="button"
            onClick={handleArrowClick('rating,desc')}>
            { sorter === 'rating,desc'
              ? null
              : <div className={styles.arrowDown} />}
          </button>
        </div>
      </div>
    </div>
  );
};
